// @generated by protoc-gen-es v1.2.0 with parameter "target=js+dts"
// @generated from file wavin/aqora/v2/issue.proto (package wavin.aqora.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import {Severity} from "./event_pb.js";

/**
 * @generated from enum wavin.aqora.v2.IssueStatus
 */
export const IssueStatus = proto3.makeEnum(
  "wavin.aqora.v2.IssueStatus",
  [
    {no: 0, name: "ISSUE_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ISSUE_STATUS_OPEN", localName: "OPEN"},
    {no: 2, name: "ISSUE_STATUS_CLOSED", localName: "CLOSED"},
  ],
);

/**
 * @generated from enum wavin.aqora.v2.IssueType
 */
export const IssueType = proto3.makeEnum(
  "wavin.aqora.v2.IssueType",
  [
    {no: 0, name: "ISSUE_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ISSUE_TYPE_DEVICE_OFFLINE", localName: "DEVICE_OFFLINE"},
    {no: 2, name: "ISSUE_TYPE_BATTERY_IS_LOW", localName: "BATTERY_IS_LOW"},
    {no: 3, name: "ISSUE_TYPE_WATER_HEIGHT_SENSOR_BROKEN", localName: "WATER_HEIGHT_SENSOR_BROKEN"},
    {no: 4, name: "ISSUE_TYPE_TEMPERATURE_SENSOR_BROKEN", localName: "TEMPERATURE_SENSOR_BROKEN"},
    {no: 5, name: "ISSUE_TYPE_VALVE_ACTUATOR_BROKEN", localName: "VALVE_ACTUATOR_BROKEN"},
    {no: 7, name: "ISSUE_TYPE_ROOF_DRY", localName: "ROOF_DRY"},
    {no: 8, name: "ISSUE_TYPE_TAP_BROKEN", localName: "TAP_BROKEN"},
    {no: 9, name: "ISSUE_TYPE_PUMP_BROKEN", localName: "PUMP_BROKEN"},
    {no: 10, name: "ISSUE_TYPE_DRAIN_CLOGGED", localName: "DRAIN_CLOGGED"},
    {no: 11, name: "ISSUE_TYPE_OVERFLOW_DRAIN_CLOGGED", localName: "OVERFLOW_DRAIN_CLOGGED"},
    {no: 12, name: "ISSUE_TYPE_RAIN_SENSOR_DATA_MISMATCH", localName: "RAIN_SENSOR_DATA_MISMATCH"},
    {no: 13, name: "ISSUE_TYPE_OVERFLOW_HEIGHT_TO_LOW", localName: "OVERFLOW_HEIGHT_TO_LOW"},
    {no: 14, name: "ISSUE_TYPE_WATER_HEIGHT_SENSOR_FLUCTUATIONS", localName: "WATER_HEIGHT_SENSOR_FLUCTUATIONS"},
  ],
);

/**
 * Issue is based on a timeframe of events with a severity of Critical or Error
 *
 * @generated from message wavin.aqora.v2.Issue
 */
export const Issue = proto3.makeMessageType(
  "wavin.aqora.v2.Issue",
  () => [
    { no: 1, name: "resource_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "severity", kind: "enum", T: proto3.getEnumType(Severity) },
    { no: 4, name: "first_occurrence_time", kind: "message", T: Timestamp },
    { no: 5, name: "last_occurrence_time", kind: "message", T: Timestamp },
    { no: 6, name: "system_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "resource_type", kind: "enum", T: proto3.getEnumType(Issue_ResourceType) },
    { no: 8, name: "resource_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "status", kind: "enum", T: proto3.getEnumType(IssueStatus) },
      {no: 10, name: "issue_type", kind: "enum", T: proto3.getEnumType(IssueType)},
  ],
);

/**
 * @generated from enum wavin.aqora.v2.Issue.ResourceType
 */
export const Issue_ResourceType = proto3.makeEnum(
  "wavin.aqora.v2.Issue.ResourceType",
  [
    {no: 0, name: "RESOURCE_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "RESOURCE_TYPE_PRODUCT", localName: "PRODUCT"},
    {no: 2, name: "RESOURCE_TYPE_RESERVOIR", localName: "RESERVOIR"},
    {no: 3, name: "RESOURCE_TYPE_PERIPHERAL", localName: "PERIPHERAL"},
  ],
);

